"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _commons = require("@stktk/commons");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// const isRecipe = (skuId, recipeSkus) => !!recipeSkus[skuId];
var getRecipeSkus = function getRecipeSkus(recipes) {
  return _lodash["default"].groupBy(recipes, "recipeSkuId");
};

var getRecipeIngredientSkus = function getRecipeIngredientSkus(recipes) {
  return (0, _lodash["default"])(recipes).filter(function (record) {
    return record.recipeSkuId === record.ingredientSkuId;
  }).groupBy("ingredientSkuId").mapValues(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        sku = _ref2[0];

    return sku;
  }).value();
};

var RecipeHelper = /*#__PURE__*/function () {
  function RecipeHelper() {
    var _this = this;

    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      recipes: []
    },
        recipes = _ref3.recipes;

    _classCallCheck(this, RecipeHelper);

    _defineProperty(this, "getRecipeIngredientRecords", function (_ref4) {
      var ratio = _ref4.ratio,
          recipeRecord = _ref4.recipeRecord,
          recordValueProperty = _ref4.recordValueProperty,
          skuValueProperty = _ref4.skuValueProperty,
          value = _ref4.value,
          _plannedProductCost = _ref4._plannedProductCost;
      var expandValue = recordValueProperty && skuValueProperty && value;
      var skuId = recipeRecord.skuId,
          status = recipeRecord.status,
          barId = recipeRecord.barId;
      var totalRecordValue = 0;

      var ingredients = _this.recipeSkus[skuId].filter(function (ingredient) {
        return ingredient.level === 2;
      }).map(function (ingredient) {
        var ingredientAmount = ingredient.ingredientAmount,
            ingredientAmountUnitId = ingredient.ingredientAmountUnitId,
            sku = ingredient.sku;
        ingredientAmount = ingredientAmount * ratio;
        var supplierId = sku.skuSuppliers.length == 1 ? sku.skuSuppliers[0].supplierId : null;
        var amountMeasurement = new _commons.Measurement({
          amount: ingredientAmount,
          unit: _commons.UnitEnum.get(ingredientAmountUnitId)
        }); // let price = getSkuDetails(sku, "domain")[skuValueProperty];

        var price = _this.getPurchaseValue({
          skuId: sku.id
        });

        var amount = (0, _commons.getSkuIngredientSkuNormalizedAmount)({
          ingredientAmount: ingredientAmount,
          ingredientAmountUnitId: ingredientAmountUnitId
        }, sku);
        var recordValue = amount * price;
        totalRecordValue += recordValue;
        return expandValue ? _objectSpread(_objectSpread({
          netPurchasePrice: null,
          netSalePrice: null,
          barId: barId,
          supplierId: supplierId,
          status: status
        }, (0, _commons.getSkuMeasurementRecord)(sku, amountMeasurement)), {}, _defineProperty({
          _plannedProductCost: _plannedProductCost,
          sku: sku
        }, recordValueProperty, recordValue)) : _objectSpread(_objectSpread({
          netPurchasePrice: null,
          netSalePrice: null,
          barId: barId,
          supplierId: supplierId,
          status: status
        }, (0, _commons.getSkuMeasurementRecord)(sku, amountMeasurement)), {}, {
          _plannedProductCost: _plannedProductCost,
          sku: sku
        });
      });

      return expandValue ? ingredients.map(function (record) {
        return _objectSpread(_objectSpread({
          netPurchasePrice: null,
          netSalePrice: null
        }, record), {}, _defineProperty({}, recordValueProperty, totalRecordValue === 0 ? 0 : value * (record[recordValueProperty] || 0) / totalRecordValue));
      }) : ingredients;
    });

    _defineProperty(this, "expandRecords", function (_ref5) {
      var records = _ref5.records,
          _ref5$valueProperties = _ref5.valueProperties;
      _ref5$valueProperties = _ref5$valueProperties === void 0 ? [null, null] : _ref5$valueProperties;

      var _ref5$valueProperties2 = _slicedToArray(_ref5$valueProperties, 2),
          _ref5$valueProperties3 = _ref5$valueProperties2[0],
          recordValueProperty = _ref5$valueProperties3 === void 0 ? null : _ref5$valueProperties3,
          _ref5$valueProperties4 = _ref5$valueProperties2[1],
          skuValueProperty = _ref5$valueProperties4 === void 0 ? null : _ref5$valueProperties4,
          _ref5$normalizeValue = _ref5.normalizeValue,
          normalizeValue = _ref5$normalizeValue === void 0 ? false : _ref5$normalizeValue;

      var currentRecords = _toConsumableArray(records);

      var nextRecords = [];
      var processedRecords = [];

      while (currentRecords.length) {
        currentRecords.forEach(function (record) {
          var skuId = record.skuId,
              sku = record.sku;
          var _plannedProductCost = (0, _commons.getSkuDetails)(sku, "domain").plannedProductCost;

          if (_this.isRecipe({
            skuId: skuId
          }) && (0, _commons.getConfigProperty)(sku, "expandable")) {
            var _nextRecords;

            var ingredientSku = _this.recipeIngredientSkus[skuId].sku;
            var ratio = (0, _commons.getTotalRecordSkuNormalizedAmount)(record, ingredientSku);
            var value = record[recordValueProperty] * record.quantity; // let __v1 = record.quantity * record.netSalePrice;

            var ingredientRecords = _this.getRecipeIngredientRecords({
              ratio: ratio,
              recipeRecord: record,
              recordValueProperty: recordValueProperty,
              skuValueProperty: skuValueProperty,
              value: value,
              _plannedProductCost: _plannedProductCost
            });

            if (normalizeValue) {
              ingredientRecords.forEach(function (record) {
                record[recordValueProperty] /= record.quantity;
              });
            } // let __v2 = ingredientRecords.map(r => r.quantity * r.netSalePrice).reduce((acc, x) => acc + x, 0);
            // if (Math.abs(__v1 - __v2) > 0.001) {
            //   console.log(sku.id, sku.name, __v1, __v2);
            // }


            (_nextRecords = nextRecords).push.apply(_nextRecords, _toConsumableArray(ingredientRecords));
          } else {
            processedRecords.push(_objectSpread(_objectSpread({}, record), {}, {
              _plannedProductCost: record._plannedProductCost || _plannedProductCost
            }));
          }
        });
        currentRecords = nextRecords;
        nextRecords = [];
      }

      return processedRecords;
    });

    this.recipes = recipes;
    this.recipeSkus = getRecipeSkus(recipes);
    this.recipeIngredientSkus = getRecipeIngredientSkus(recipes);
    this._skus = {};
  }

  _createClass(RecipeHelper, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.recipes.forEach(function (record) {
        var ingredientSkuId = record.ingredientSkuId,
            sku = record.sku; // sku.id === ingredientSkuId

        var purchaseValue = null,
            computed = false;

        if (sku.type === _commons.SkuTypeEnum.SIMPLE) {
          purchaseValue = (0, _commons.getSkuDetails)(sku, "domain").netPurchasePrice;
          computed = true;
        }

        _this2._skus[ingredientSkuId] = {
          sku: sku,
          purchaseValue: purchaseValue,
          computed: computed
        };
      });
    }
  }, {
    key: "computePurchaseValues",
    value: function computePurchaseValues() {
      var _this3 = this;

      this.initialize();
      this.recipes.forEach(function (record) {
        var ingredientSkuId = record.ingredientSkuId,
            sku = record.sku; // sku.id === ingredientSkuId

        if (sku.type === _commons.SkuTypeEnum.COMPOUND) _this3.getPurchaseValue({
          skuId: ingredientSkuId
        });
      });
    }
  }, {
    key: "getRecipeSkus",
    value: function getRecipeSkus() {
      return this.recipeSkus;
    }
  }, {
    key: "getRecipeIngredientSkus",
    value: function getRecipeIngredientSkus() {
      return this.recipeIngredientSkus;
    }
  }, {
    key: "getRecipes",
    value: function getRecipes() {
      return this.recipes;
    }
  }, {
    key: "isRecipe",
    value: function isRecipe(_ref6) {
      var skuId = _ref6.skuId;
      var record = this.recipeIngredientSkus[skuId];
      return record ? record.sku.type === _commons.SkuTypeEnum.COMPOUND : false;
    }
  }, {
    key: "getSku",
    value: function getSku(_ref7) {
      var skuId = _ref7.skuId;
      return this._skus[skuId].sku;
    }
  }, {
    key: "getPurchaseValue",
    value: function getPurchaseValue(_ref8) {
      var _this4 = this;

      var skuId = _ref8.skuId;
      var _sku = this._skus[skuId];
      if (_sku && _sku.computed) return _sku.purchaseValue;else {
        // const [{ sku }] = this.recipeSkus[skuId].filter((entry) => entry.level === 1);
        var value = this.recipeSkus[skuId].filter(function (entry) {
          return entry.level === 2;
        }).map(function (entry) {
          var ingredientAmount = entry.ingredientAmount,
              ingredientAmountUnitId = entry.ingredientAmountUnitId,
              sku = entry.sku;

          var price = _this4.getPurchaseValue({
            skuId: sku.id
          });

          var amount = (0, _commons.getSkuIngredientSkuNormalizedAmount)({
            ingredientAmount: ingredientAmount,
            ingredientAmountUnitId: ingredientAmountUnitId
          }, sku);
          return price * amount;
        }).reduce(function (value, acc) {
          return acc + value;
        }, 0);
        _sku.purchaseValue = value;
        _sku.computed = true;
        return value;
      }
    }
  }, {
    key: "getSaleValue",
    value: function getSaleValue(_ref9) {
      var skuId = _ref9.skuId;
      var sku = this._skus[skuId];
      return (0, _commons.getSkuDetails)(sku, "domain").netSalePrice;
    }
  }]);

  return RecipeHelper;
}();

exports["default"] = RecipeHelper;